import React from 'react';
import { DocPageLayout } from '../../components/DocPageLayout';
import { InfoBox } from '../../components/InfoBox';
interface CheckoutTestingPageProps {
  onNavigate?: (pageId: string) => void;
}
export function CheckoutTestingPage({
  onNavigate
}: CheckoutTestingPageProps) {
  return <DocPageLayout title="Testing Steps" data-id="element-1457">
      <div className="text-sm text-gray-500 mb-6 -mt-8" data-id="element-1458">
        <button onClick={() => onNavigate?.('overview')} className="hover:underline text-orange-600" data-id="element-1459">
          Overview
        </button>{' '}
        &gt;{' '}
        <button onClick={() => onNavigate?.('checkout')} className="hover:underline text-orange-600" data-id="element-1460">
          &lt;&lt;checkout&gt;&gt;
        </button>{' '}
        &gt; Testing Steps
      </div>

      <p className="text-gray-700 mb-6" data-id="element-1461">
        Before going live, thoroughly test your integration using the test
        environment and test cards provided below.
      </p>

      <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4" data-id="element-1462">Test Cards</h2>
      <div className="overflow-x-auto mb-8" data-id="element-1463">
        <table className="w-full text-sm border border-gray-200 rounded-lg overflow-hidden" data-id="element-1464">
          <thead data-id="element-1465">
            <tr className="bg-gray-50" data-id="element-1466">
              <th className="text-left px-4 py-3 font-semibold text-gray-900 border-b" data-id="element-1467">
                Card Brand
              </th>
              <th className="text-left px-4 py-3 font-semibold text-gray-900 border-b" data-id="element-1468">
                Card Number
              </th>
              <th className="text-left px-4 py-3 font-semibold text-gray-900 border-b" data-id="element-1469">
                Result
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200" data-id="element-1470">
            <tr data-id="element-1471">
              <td className="px-4 py-3" data-id="element-1472">Mastercard</td>
              <td className="px-4 py-3 font-mono text-xs" data-id="element-1473">
                5123 4500 0000 0008
              </td>
              <td className="px-4 py-3 text-green-600" data-id="element-1474">Approved</td>
            </tr>
            <tr className="bg-gray-50/50" data-id="element-1475">
              <td className="px-4 py-3" data-id="element-1476">Visa</td>
              <td className="px-4 py-3 font-mono text-xs" data-id="element-1477">
                4508 7500 1574 1019
              </td>
              <td className="px-4 py-3 text-green-600" data-id="element-1478">Approved</td>
            </tr>
            <tr data-id="element-1479">
              <td className="px-4 py-3" data-id="element-1480">Mastercard</td>
              <td className="px-4 py-3 font-mono text-xs" data-id="element-1481">
                5123 4500 0000 0016
              </td>
              <td className="px-4 py-3 text-red-600" data-id="element-1482">Declined</td>
            </tr>
            <tr className="bg-gray-50/50" data-id="element-1483">
              <td className="px-4 py-3" data-id="element-1484">Visa</td>
              <td className="px-4 py-3 font-mono text-xs" data-id="element-1485">
                4508 7500 1574 1027
              </td>
              <td className="px-4 py-3 text-red-600" data-id="element-1486">Declined</td>
            </tr>
          </tbody>
        </table>
      </div>

      <InfoBox type="tip" title="Test Card Details" data-id="element-1487">
        Use any future expiry date and any 3-digit CVV (e.g., 100) with the test
        cards above.
      </InfoBox>

      <h2 className="text-2xl font-bold text-gray-900 mt-10 mb-4" data-id="element-1488">
        Test Scenarios
      </h2>
      <ul className="list-disc list-inside space-y-3 text-gray-700 ml-4 mb-8" data-id="element-1489">
        <li data-id="element-1490">
          <strong data-id="element-1491">Successful payment:</strong> Complete a payment with an
          approved test card and verify the result.
        </li>
        <li data-id="element-1492">
          <strong data-id="element-1493">Declined payment:</strong> Attempt a payment with a declined
          test card and verify error handling.
        </li>
        <li data-id="element-1494">
          <strong data-id="element-1495">3D Secure challenge:</strong> Test the 3DS authentication flow
          with a 3DS-enrolled test card.
        </li>
        <li data-id="element-1496">
          <strong data-id="element-1497">Cancelled payment:</strong> Cancel the payment from the hosted
          page and verify the cancel callback.
        </li>
        <li data-id="element-1498">
          <strong data-id="element-1499">Session expiry:</strong> Wait for the session to expire and
          verify the timeout handling.
        </li>
        <li data-id="element-1500">
          <strong data-id="element-1501">Subsequent operations:</strong> Test capture, refund, and void
          operations after a successful payment.
        </li>
      </ul>

      <h2 className="text-2xl font-bold text-gray-900 mt-10 mb-4" data-id="element-1502">
        Test Environment
      </h2>
      <p className="text-gray-700 mb-4" data-id="element-1503">
        All testing should be performed against the test gateway endpoint:
      </p>
      <div className="bg-gray-50 p-4 rounded-lg border border-gray-200 mb-6 font-mono text-sm" data-id="element-1504">
        https://test-gateway.mastercard.com/api/rest/version/72/merchant/
        {'{merchantId}'}
      </div>
    </DocPageLayout>;
}